export var ActivityApplicationStatusType;
(function (ActivityApplicationStatusType) {
    ActivityApplicationStatusType["CREATED"] = "created";
    ActivityApplicationStatusType["LOCKED"] = "locked";
    ActivityApplicationStatusType["PASSED"] = "passed";
    ActivityApplicationStatusType["REJECTED"] = "rejected";
    ActivityApplicationStatusType["CANCELLED"] = "cancelled";
})(ActivityApplicationStatusType || (ActivityApplicationStatusType = {}));
//# sourceMappingURL=ActivityApplicationStatusType.js.map